import React from 'react'
import BodyLayout from './BodyLayout'
import GlobalLoading from './GlobalLoading'

const Fallback = () => (
  <BodyLayout>
    <GlobalLoading />
  </BodyLayout>
)

export default Fallback
